import { render, staticRenderFns } from "./rightDrawer.vue?vue&type=template&id=345095b6"
import script from "./rightDrawer.vue?vue&type=script&lang=js"
export * from "./rightDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports